import { getChangeTypeToChangeLabel } from './@arch/lib';
import React from 'react';
import { SonarText } from '@ui/text';
import { VersionNumber } from '@ui/VersionNumber';
import { When } from 'react-if';
import { convertISODateToShortDate, getSonarObjectTypeAndSourceLabel } from '@sonar-software/sonar-ts-lib';
import { COPY_SPECIFIC, TIMELINE_TABLE_DATA_INDICES } from '@sonar-software/sonar-ts-constants';
import { Space, Tag } from 'antd';
const dateColumn = {
    key: 'date',
    render: (record) => { var _a, _b; return convertISODateToShortDate((_b = (_a = record.change) === null || _a === void 0 ? void 0 : _a.timestamp) !== null && _b !== void 0 ? _b : ''); },
    sorter: true,
    title: COPY_SPECIFIC.DATE
};
const displayNameColumn = {
    key: 'displayName',
    render: (record) => {
        const { displayName, parentDisplayName, versionNumber } = record;
        return (React.createElement(Space, { wrap: true },
            displayName,
            React.createElement(VersionNumber, { number: versionNumber }),
            React.createElement(When, { condition: parentDisplayName },
                React.createElement(Tag, null, parentDisplayName))));
    },
    sorter: true,
    title: COPY_SPECIFIC.DISPLAY_NAME
};
const objectTypeColumn = {
    dataIndex: TIMELINE_TABLE_DATA_INDICES.SONAR_OBJECT_TYPE,
    key: 'sonarObjectType',
    render: getSonarObjectTypeAndSourceLabel,
    sorter: true,
    title: COPY_SPECIFIC.TYPE
};
const changeTypeColumn = {
    dataIndex: ['change', TIMELINE_TABLE_DATA_INDICES.CHANGE_TYPE],
    key: 'changeType',
    render: (type) => React.createElement(SonarText, { className: type }, getChangeTypeToChangeLabel(type)),
    sorter: true,
    title: COPY_SPECIFIC.CHANGE
};
const modifiedByColumn = {
    dataIndex: TIMELINE_TABLE_DATA_INDICES.LAST_MODIFIED_BY_NAME,
    key: 'modifiedBy',
    sorter: true,
    title: COPY_SPECIFIC.MODIFIED_BY
};
export function getTimelineDetailColumns() {
    return [dateColumn, displayNameColumn, objectTypeColumn, changeTypeColumn, modifiedByColumn];
}
